import Vue from 'vue'
import Vuex from 'vuex'
import notifycation from './modules/notifycation';
import {GET_AREAS, getAreaWiring, transformerList} from '../api/power.js'
import proto from "../components/proto";
import {subscribe} from '../mqtt/index'

Vue.use(Vuex)

let project = {
    state: {
        diagramStatus: {},
        currentProject: {
            projectId: 0,
            areaId: -1,
            areaList: {
                distribution: [],
                photovoltaic: [],
                energyStorage: []
            }
        },
        Radio: {
            proId: 0
        },
        WeatherInfo: {//天气质量
            text: "-",
            temp: "-",
            humidity: "-",
            category: "-"
        },
        transformerList: [],
        projectGroup: {}, //所有项目权限
        RecentlyUsed: [], //最近使用保存
        AreaInfo: [],  //选择站点信息
        projectInfo: {}, //项目信息
        EnterpriseInfo: {},//企业信息
        costOperation: {}, // 账单运营成本构成 联动
        FirstPage: {}, //工作台默认第一个
        CurrWorkBenchPage: "",//工作台选中
        monitorList: [],
        AlarmEvent: {},  //最新报警信息
        pileIsSelect: 0
    },
    mutations: {
        setProjectInfo: (state, data) => {
            Vue.set(state, "projectInfo", data)
        },
        exportDiagram: (state, data) => {
            Vue.set(state, "diagramStatus", data)
        },
        setProjectId: (state, data) => {
            state.currentProject.projectId = data
        },
        ForegroundRadio: (state, data) => {
            state.Radio.proId = data
        },
        setWeatherInfo: (state, data) => {
            Vue.set(state, "WeatherInfo", data)
        },
        setAreaId(state, data) {
            state.currentProject.areaId = data
        },
        getTransformerList(state, list) {
            state.transformerList = list
        },
        setProjectGroup(state, data) {
            Vue.set(state, "projectGroup", data)
        },
        setAreaList(state, data) {
            state.currentProject.areaList = data
        },
        setRecentlyUsed(state, data) {
            state.RecentlyUsed = data
        },
        setAreaInfo(state, data) {
            state.AreaInfo = data
        },
        setEnterpriseInfo(state, data) {
            state.EnterpriseInfo = data
        },
        getCostOperation(state, group) {
            state.costOperation = group
        },
        setFirstPage(state, data) {
            state.FirstPage = data
        },
        setCurrWorkBench(state, data) {
            state.CurrWorkBenchPage = data
        },
        setMonitorList(state, list) {
            state.monitorList = list
        },
        setAlarmEvent(state, data) {
            state.AlarmEvent = data
        },
        setPileIsSelect(state, data) {
            state.pileIsSelect = data
        }
    },
    actions: {
        async getSiteList({commit}) {
            try {
                let res = await GET_AREAS()
                // console.log(res);
                let siteList = res.data.data.areas
                if (siteList.length == 0) {
                    commit('getTransformerList', [])
                    commit('setAreaList', [])
                    return false
                }
                let obj = {
                    distribution: [],
                    photovoltaic: [],
                    energyStorage: []
                }
                siteList.forEach(item => {
                    if (item.areaType == 1) {
                        obj.distribution.push(item)
                    } else if (item.areaType == 2) {
                        obj.photovoltaic.push(item)
                    } else if (item.areaType == 3) {
                        obj.energyStorage.push(item)
                    }
                })

                for (let key in obj) {
                    obj[key].forEach(async item => {
                        try {
                            let res = await getAreaWiring({
                                areaId: item.areaId,
                                wiringType: key == 'distribution' ? 1 : key == 'photovoltaic' ? 2 : 3
                            })
                            if (res.data.code == 200 && res.data.data.length > 0) {

                                let arr = []
                                res.data.data.forEach(item => {
                                    arr.push(item.wirings[0])
                                })
                                item.wiringList = arr
                                // console.log(arr);
                            } else {
                                item.wiringList = []
                                // console.log(res.data.errMsg);
                            }
                        } catch (err) {
                            console.log(err);
                        }

                    })
                }
                console.log(obj, "obj")
                let ProjectTransformerList = []
                obj.distribution.forEach(async (item, index) => {
                    let res = await transformerList(item.areaId)
                    if (res.data.code == 200) {
                        if (res.data.data.list && res.data.data.list.length > 0) {
                            item.transformerList = res.data.data.list

                            ProjectTransformerList = ProjectTransformerList.concat(res.data.data.list)
                            item.transformerList.forEach(item => {
                                subscribe([item.subLoopUrl])
                            })
                        } else {
                            item.transformerList = []
                        }
                    } else {
                        // console.log(res.data.errMsg);
                        item.transformerList = []
                    }

                    if (index == obj.distribution.length - 1) {
                        setTimeout(() => {
                            commit('getTransformerList', ProjectTransformerList)
                            commit('setAreaList', obj)
                        }, 100)
                    }
                })

            } catch (err) {
                console.log(err);
            }
        },
        websocketConnect({commit, state}) {
            // let ws = new WebSocket('ws://220.249.101.248:37087/ebox/life');
            let ws = new WebSocket("wss://local.vrmaker.vip:37087/ebox/life");
            // let ws = new WebSocket("wss://local.vrmaker.vip:1443/api_ws/ebox/life");
            ws.binaryType = "arraybuffer";
            ws.onmessage = (res) => {
                let uint8Array = new Uint8Array(res.data);
                let messageBody = proto.MessageBody.decode(uint8Array);
                if (messageBody.dataType === 2) {
                    // console.log(messageBody.eBoxInfoList.eBoxInfos)
                    commit("setEBoxInfo", messageBody.eBoxInfoList.eBoxInfos);
                }
                if (messageBody.dataType === 3) {
                    console.log(messageBody, "messageBody")
                    let data = JSON.parse(messageBody.alarmEvent.jsonData)
                    if (data.level != 'notice' && data.projectId == state.currentProject.projectId) {
                        commit("setAlarmEvent", JSON.parse(messageBody.alarmEvent.jsonData));
                    }
                }
            };
        },
    },
    getters: {
        projectId: (state) => {
            return state.currentProject.projectId
        },
        areaId: (state) => {
            return state.currentProject.areaId
        },
        selAreaInfo: (state) => {
            // let projectId = state.currentProject.projectId
            // let areaId = state.currentProject.areaId
            // let list = state.projectGroup.map(e=>e.projectList)
            // let obj = list.filter(e=>{
            //     e = e.filter(l=>{
            //         if(l.projectId==projectId){
            //             return l
            //         }
            //     })
            //     if(e.length>0){
            //         return e
            //     }
            // })
            // obj[0][0].areaList.filter(e=>e.areaId==areaId)[0]
            return state.AreaInfo
        },
        selProjectInfo: (state) => {
            return state.projectInfo
        },
        getTypeSite(state) {
            return (type) => {
                return state.currentProject.areaList[type]
            }
        },
        getAreaTransformer(state) {
            return state.currentProject.areaList['distribution'].filter(item => item.transformerList.length > 0)
        },
        getWebUrl(state) {
            return state.EnterpriseInfo.projectList.find(item => item.projectId == state.currentProject.projectId).webUrl
        }
    },
}

let token = {
    state: {
        token: "",
        isLogin: false,
    },
    mutations: {
        setToken: (state, token) => {
            state.isLogin = true
            state.token = token

        }
    },
    actions: {},
    getters: {},

}

let mqtt = {
    state: {
        all: {},
        alarm: {},
        max: {},
        mean: {},
        min: {}
    },
    mutations: {
        addMqttVal: (state, data) => {
            Vue.set(state.all, data.key, data.val)
        },
        addAlarm: (state, data) => {
            Vue.set(state.alarm, data.key, data.val)
        },
        restMqtt(state) {
            state.all = {}
            console.log(state.all);
        }

    },
    actions: {
        asyncAddMqttVal: ({
                              state
                          }, data) => {
            Vue.set(state.all, data.key, data.val)
        },
        addMqttValList: ({
                             state
                         }, list) => {
            list.forEach(data => {
                let key = data.key;
                let value = data.val;
                Vue.set(state.all, key, value)
                let current = state.max[key];
                if (current && current.val !== 0) {
                    if (current < value) {
                        Vue.set(state.max, key, {
                            val: value,
                            time: new Date()
                        })
                    }
                } else {
                    Vue.set(state.max, key, {
                        val: value,
                        time: new Date()
                    })
                }


                let currentMean = state.mean[key];
                if (currentMean) {
                    currentMean.val = (currentMean.val * currentMean.n + value) / (currentMean.n + 1)
                    currentMean.n = currentMean.n + 1
                } else {
                    Vue.set(state.mean, key, {
                        val: value,
                        n: 1
                    })
                }

                let currentMin = state.min[key]
                if (currentMin && currentMin.val !== 0) {
                    if (currentMin.val > value) {
                        Vue.set(state.min, key, {
                            val: value,
                            time: new Date()
                        })
                    }
                } else {
                    Vue.set(state.min, key, {
                        val: value,
                        time: new Date()
                    })
                }

            })
        }
    },
    getters: {
        mqttMinVal: state => key => state.min[key],
        mqttMeanVal: state => key => state.mean[key],
        mqttMaxVal: state => key => state.max[key],
        mqttVal: state => key => state.all[key],
        isAlarm: state => (loop, node) => {
            let alarmElement = state.alarm[`/${loop.subLoopUrl}/alarm/${node}`];
            if (alarmElement === undefined) {
                return false
            } else {
                return !alarmElement
            }
        }
    },
}
let homeitem = {
    state: {
        user: [],
        IformId: 0,
    },
    mutations: {
        NavformDataId: (state, data) => {
            state.IformId = data
        },
        setUser(state, data) {
            state.user = data
        },

    },
    actions: {},
    getters: {},

}

export default new Vuex.Store({
    state: {},
    mutations: {
        clear: state => {
            state = {}
        }
    },
    actions: {},

    modules: {
        project,
        token,
        mqtt,
        homeitem,
        notifycation
    }
})